export default __webpack_public_path__ + "static/media/TIRONEM_LOGO.86e8f486.png";